declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_array_spread_other_bar extends $mol_object {
		sup( ): readonly(any)[]
		arr( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=array_spread_other_channel.view.tree.d.ts.map